module.exports = __webpack_public_path__ + "static/media/friends-hero-m.0389669b.webp";